export default {
  settings: {
    title: 'Einstellungen',
    account_related: 'Konto-Informationen',
    // user_related: "",
    add_user_title: 'Benutzer hinzufügen',
    edit_user_title: 'Benutzer bearbeiten',
    label: {
      enabled: 'Aktiviert',
      not_set: 'Nicht festgelegt',
    },
    company: {
      title: 'Informationen zum Unternehmen',
      name: 'Name des Unternehmens',
      english_name: 'English name',
      scale: 'Anzahl der Mitarbeiter',
      industry_type: 'Branche',
      plan: 'Plan',
      location: 'Adresse',
      allowed_ip: 'Erlaubte IP-Adressen',
      mfa: 'SMS-Authentifizierung',
      sales_amount: 'Einnahmen',
      country: 'Land',
    },
    contract_plans: {
      buyer: 'Plan des Käufers',
      supplier: 'Plan des Lieferanten',
    },
    user: {
      title: 'Benutzerliste',
      name: 'Name',
      first_name: 'Nachname',
      last_name: 'Vorname',
      email: 'E-Mail Adresse',
      email_unverified: 'Vor der Registrierung',
      password: 'Passwort',
      password_protection: 'Aus Sicherheitsgründen versteckt',
      phone_number: 'Telefon Nummer',
      role: {
        title: 'Berechtigung',
        admin: 'Admin',
        general: 'Allgemein',
      },
      locale: 'Sprache auswählen',
      action: 'Operation',
      total: 'Alle: {total}(Max: {max})',
    },
    button: {
      create: 'Benutzer hinzufügen',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: 'Hinweis',
    cautions_01: 'Sie können Ihre E-Mail Adresse nicht ändern. Um Ihre E-Mail zurückzusetzen, erstellen Sie bitte einen neuen Benutzer.',
    cautions_02: 'Eine Telefonnummer ist erforderlich, wenn die SMS-Authentifizierung aktiviert ist.',
    cautions_03: 'Um Ihr Passwort zurückzusetzen, geben Sie bitte den Bestätigungscode, den Sie an Ihre registrierte E-Mail-Adresse erhalten haben, in den Bildschirm zum Zurücksetzen des Passworts ein.',
    cautions_04: 'Wenn Sie einen Benutzer löschen, werden die Antwortdaten oder die Scorecard nicht gelöscht.',
    messages: {
      user_update: 'Benutzerinformationen aktualisieren',
      user_delete: 'Benutzer löschen',
      confirm_delete: 'Möchten Sie diesen Benutzer löschen?',
      // complete_create: "",
      complete_update: 'Die Benutzerinformationen wurden aktualisiert.',
      complete_delete: 'Die Löschung der Benutzerinformationen ist abgeschlossen.',
      disabled_delete: 'Mindestens ein Benutzer muss eine „Admin“-Berechtigung haben.',
      disabled_delete_by_auth: 'Nur Admin kann löschen.',
      invalid_form: 'Falsche Eingabe.',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: 'Nachdem Sie auf „HINZUFÜGEN“ geklickt haben, wird eine Bestätigungs-E-Mail an die von Ihnen angegebene E-Mail-Adresse gesendet. \nAnschließend erhalten Sie eine E-Mail mit Ihrer Anmelde-ID und Ihrem Passwort.',
      caution_two: 'Eine Telefonnummer ist erforderlich, wenn die SMS-Authentifizierung aktiviert ist.',
      caution_three: 'Es können bis zu 5 Benutzer hinzugefügt werden.',
      user_add_title: 'Benutzer hinzufügen',
      user_add_message_one: 'Wir haben eine E-Mail an die von Ihnen angegebene Adresse geschickt. ',
      user_add_message_two: 'Bitte prüfen Sie Ihre E-Mail und folgen Sie den Anweisungen in der E-Mail, um sich einzuloggen.',
    },
    tips: {
      role: 'Die Berechtigung "Admin" kann Benutzer hinzufügen und löschen, die Berechtigung "Allgemein" jedoch nicht.',
      locale: 'Sie können die anfängliche Spracheinstellung nach der Anmeldung auswählen.',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: 'Sind Sie sicher, dass Sie sich abmelden und zur Seite zum Zurücksetzen des Passworts gehen möchten? Auf der Seite zum Zurücksetzen des Passworts geben Sie bitte den Verifizierungscode ein, den Sie in der E-Mail erhalten haben, die an Ihre registrierte E-Mail-Adresse gesendet wurde.',
      reset: 'Passwort zurücksetzen',
    },
  },
}
